<script setup>
import { ref, computed, watch } from 'vue';
import InputNumerico from './InputNumerico.vue';
import { isBlank } from '../../libs/strings';

const props = defineProps({
  label: { type: String, default: null },
  name: { type: String, default: '' },
  size: { type: String, default: 'md' },
  modelValue: { type: [String, Number], default: null },
  disabled: { type: Boolean, default: false },
  min: { type: Number, default: 0 },
  max: { type: Number, default: 99 },
  inputId: { type: String, default: undefined },
  inputClass: { type: String, default: '' },
  puedeBorrar: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const input = ref(null);
const valorInterno = ref(
  isBlank(props.modelValue) ? null : parseInt(props.modelValue.toString(), 10),
);

const inputClasses = computed(() => {
  return `text-center form-control input-${props.size} ${props.inputClass}`;
});

const wrapperClasses = computed(() => {
  let clases = '';
  if (props.max > 999) {
    clases = 'wrapper-4-digitos';
  } else if (props.max > 99) {
    clases = 'wrapper-3-digitos';
  } else {
    clases = 'wrapper-2-digitos';
  }
  if (props.puedeBorrar) {
    clases += '-wide';
  }
  return `wrapper-${props.size} ${clases}`;
});

const seleccionarValor = () => {
  input.value.select();
};

const asegurarValor = () => {
  // Provoca que se controle el mínimo y máximo
  asignarValor(valorInterno.value);
};

const asignarValor = (valorOriginal) => {
  let valor = Number.isNaN(valorOriginal) ? 0 : valorOriginal;
  if (props.max !== undefined) {
    valor = Math.min(valor, props.max);
  }
  if (props.min !== undefined) {
    valor = Math.max(valor, props.min);
  }
  valorInterno.value = valor;
  emit('update:modelValue', valorInterno.value);
};
const incrementarValor = (incremento) => {
  asignarValor(valorInterno.value + incremento);
};

const cambiaValor = () => {
  asegurarValor();
};

const borrarValor = () => {
  input.value.asignarValorAutonumeric(null);
  valorInterno.value = null;
};

watch(
  () => props.modelValue,
  () => {
    valorInterno.value = props.modelValue
      ? parseInt(props.modelValue, 10)
      : null;
  },
);
</script>

<template>
  <div class="selector-numerico-wrapper" :class="wrapperClasses">
    <label v-if="label" for="">{{ label }}</label>

    <div :class="`input-group input-group-${size}`">
      <span class="input-group-btn">
        <button
          type="button"
          class="btn btn-default menos"
          :disabled="disabled"
          @click="incrementarValor(-1)"
        >
          <span class="fa fa-minus"></span>
        </button>
      </span>
      <InputNumerico
        :id="inputId"
        ref="input"
        v-model="valorInterno"
        configuracion="entero"
        :class="inputClasses"
        :name="name"
        :disabled="disabled"
        :min="min"
        :max="max"
        @update:model-value="cambiaValor"
        @focus="seleccionarValor"
        @blur="asegurarValor"
      />
      <span class="input-group-btn">
        <button
          type="button"
          class="btn btn-default mas"
          :disabled="disabled"
          @click="incrementarValor(1)"
        >
          <span class="fa fa-plus"></span>
        </button>
        <button
          v-if="puedeBorrar"
          type="button"
          class="btn borrar"
          :disabled="disabled"
          @click="borrarValor()"
        >
          <span class="fa fa-eraser"></span>
        </button>
      </span>
    </div>
  </div>
</template>

<style scoped>
  .wrapper-3-digitos,
  .wrapper-2-digitos {
    width: 130px;
  }
  .wrapper-3-digitos-wide,
  .wrapper-2-digitos-wide{
    width: 160px;
  }
  .wrapper-4-digitos{
    width: 150px;
  }
  .wrapper-4-digitos-wide{
    width: 180px;
  }
  .wrapper-sm.wrapper-2-digitos {
    width: 100px;
  }
  .wrapper-sm.wrapper-3-digitos {
    width: 110px;
  }
</style>
